import { UserFormWidget } from "../../../widgets/user-form/ui/UserFormWidget";

export const UserEditPage = () => <UserFormWidget />;
